(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.featured-collection__view-more-buttons').forEach(function(el) {
  const inner = el.closest('.featured-collection__inner')
  const hides = inner.querySelectorAll('.more-item')
  const button = el.querySelector('.button-title')
  el.addEventListener('click', e => {
    if (button.getAttribute('title') == el.getAttribute('data-view-more')) {
      hides.forEach(item => { item.classList.remove('is-hidden') })
      button.innerText = el.getAttribute('data-view-less')
      button.title = el.getAttribute('data-view-less')
    } else {
      hides.forEach(item => { item.classList.add('is-hidden') })
      button.innerText = el.getAttribute('data-view-more') + el.getAttribute('data-view-extra')
      button.title = el.getAttribute('data-view-more')
      inner.scrollIntoView()
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.media-grid--mobile-button').forEach(function (el) {
    let hides = el.closest('.media-grid').querySelectorAll('.more-item');
    let button = el.querySelector('.button-title');
    el.addEventListener('click', (e) => {
      if (button.getAttribute('title') == el.getAttribute('data-view-more')) {
        hides.forEach((item) => { item.classList.remove('mobile-hide') });
        button.innerText = el.getAttribute('data-view-less');
        button.title = el.getAttribute('data-view-less');
      } else {
        hides.forEach((item) => { item.classList.add('mobile-hide') });
        button.innerText = el.getAttribute('data-view-more') + el.getAttribute('data-view-extra');
        button.title = el.getAttribute('data-view-more');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
